import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mr-5" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Accueil")
], -1)
const _hoisted_2 = { class: "d-flex row justify-content-start" }
const _hoisted_3 = { class: "col-md-3" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "col-md-4 col-lg-3" }
const _hoisted_7 = { class: "col-md-4 col-lg-3" }
const _hoisted_8 = { class: "col-md-4 col-lg-3" }
const _hoisted_9 = { class: "col-md-4 col-lg-3" }
const _hoisted_10 = { class: "col-md-4 col-lg-3" }
const _hoisted_11 = { class: "col-md-4 col-lg-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rows_counter = _resolveComponent("rows-counter")!
  const _component_yams_template = _resolveComponent("yams-template")!

  return (_openBlock(), _createBlock(_component_yams_template, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_rows_counter, {
            premier_titre: "Parc auto",
            second_titre: "Vehicules",
            icon: "/yams-rowcounter/vehicules.png",
            description: "Tous les vehicules enregistrés à votre compte",
            linkName: "vehicules",
            url: "/api/vehicules?req_count=1"
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_rows_counter, {
            premier_titre: "Operations",
            second_titre: "Courses",
            icon: "/yams-rowcounter/courses.png",
            linkName: "courses",
            description: "Courses réalisées ",
            url: "/api/courses?req_count=1"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_rows_counter, {
            premier_titre: "Operations",
            second_titre: "Réservations",
            icon: "/yams-rowcounter/reservation.png",
            linkName: "demandes",
            description: "Toutes les demandes de course en attente ",
            url: "/api/demandes?statut=En attente&req_count=1"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_rows_counter, {
            premier_titre: "Clients",
            second_titre: "Clients",
            icon: "/yams-rowcounter/client.png",
            linkName: "clients",
            description: "Clients repertoriés",
            url: "/api/utilisateurs?type=client&req_count=1"
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_rows_counter, {
            premier_titre: "Transporteurs",
            second_titre: "Entreprises",
            icon: "/yams-rowcounter/entreprises.png",
            linkName: "transporteurs",
            description: "Entreprises de transport",
            url: "/api/utilisateurs?sous_type=entreprise&req_count=1"
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_rows_counter, {
            premier_titre: "Transporteurs",
            second_titre: "Camionneurs",
            icon: "/yams-rowcounter/camionneurs.png",
            linkName: "transporteurs",
            description: "Proprietaires de vehicule",
            url: "/api/utilisateurs?sous_type=camionneur&req_count=1"
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_rows_counter, {
            premier_titre: "Transporteurs",
            second_titre: "Coursiers",
            icon: "/yams-rowcounter/coursiers.png",
            linkName: "transporteurs",
            description: "Les coursiers enregistrés",
            url: "/api/utilisateurs?sous_type=coursier&req_count=1"
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_rows_counter, {
            premier_titre: "transporteurs",
            second_titre: "Comptes",
            icon: "/yams-rowcounter/comptes.png",
            linkName: "transporteurs",
            description: "Tout les utilisateurs enregistrés",
            url: "/api/utilisateurs?req_count=1"
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_rows_counter, {
            premier_titre: "Utilisateurs",
            second_titre: "Utilisateurs connectés",
            icon: "/yams-rowcounter/user-connected.svg",
            linkName: "active-users",
            description: "Utilisateurs actuellement en ligne",
            url: "/api/utilisateurs/connected?req_count=1"
          })
        ])
      ])
    ]),
    _: 1
  }))
}